export const startupPuppeteerLoading = (document: Document) => {
	// Se for uma requisição do puppeteer, inicia o carregamento das imagens

	const isFrompuppeteer: boolean = localStorage.getItem('puppeteer') != null
	if (!isFrompuppeteer) return

	console.log('Starting loading puppeteer images for export')
	localStorage.removeItem('puppeteer')
	document.title = 'Relatório'

	observeImages(document)
}

const observeImages = (document: Document) => {
	const observer = new MutationObserver(() => {
		const imageElements = document.querySelectorAll('img')
		if (imageElements.length > 0) {
			observer.disconnect()
			waitForImagesToLoad(document).then(() => {
				console.log('puppeteer images loaded')
				insertDivOfFullLoad(document)
			})
		}
	})

	observer.observe(document.body, {
		childList: true,
		subtree: true
	})
}

const insertDivOfFullLoad = (document: Document) => {
	const puppeteerDiv = document.createElement('div')

	puppeteerDiv.className = 'render-for-puppeteer'
	puppeteerDiv.setAttribute('style', 'display: none')

	const body = document.body
	if (body.firstChild) {
			body.insertBefore(puppeteerDiv, body.firstChild)
	} else {
			body.appendChild(puppeteerDiv)
	}

	console.log('Div of full load inserted')
}

const waitForImagesToLoad = async (document: Document): Promise<void> => {
	const images = document.querySelectorAll('img')
	const imageLoadPromises = Array.from(images).map(image => {
		if (image.complete) {
			return Promise.resolve()
		}
		return new Promise<void>((resolve, reject) => {
			image.addEventListener('load', () => resolve())
			image.addEventListener('error', () => reject(new Error(`Failed to load image: ${image.src}`)))
		})
	})

	await Promise.all(imageLoadPromises)
}
